// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"31d6cfe0","2157":"c7d9f417","3473":"d0f5949e","6028":"aaa8cb31","6271":"c7d9f417","8688":"9923b5b2"}[chunkId] + ".chunk.css";
};